var map = {
	"./amex.png": 930,
	"./diners.png": 931,
	"./discover.png": 932,
	"./jcb.png": 933,
	"./maestro.png": 1156,
	"./mastercard.png": 934,
	"./stripe.png": 935,
	"./union.png": 936,
	"./unknown.png": 615,
	"./visa.png": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1155;